/**
 * Tests if a text contains the search query using case-insensitive matching.
 * Automatically escapes special regex characters in the query to prevent regex injection.
 *
 * @param text - The text to search in
 * @param query - The search query
 * @returns true if the text contains the query (case-insensitive), false otherwise
 */
export const matchesCaseInsensitive = (text: string, query: string): boolean => {
    // Escape special regex characters to prevent regex injection
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return new RegExp(escapedQuery, "i").test(text);
};
